import { erpAxios } from '..';

const deleteAnalysis = async (data) => {
  const res = await erpAxios.delete(`/analiza/${data.brojZahtjeva}/${data.komitent}`);
  return res;
};

export default deleteAnalysis;
